import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './ModalCreateEditUser.scss';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import _ from "lodash";
import { logoutUser, updateCurrentUser } from '../../services/userServices';
import { useNavigate } from 'react-router-dom';

const ModalEditUser = (props) => {
    const { dataModalUserUpdate } = props;
    let navigate = useNavigate();

    const validInputDefault = {
        password: true,
        phoneNumber: true,
        email: true,
    };

    const defaultUserData = {
        userCode: '',
        password: '',
        phoneNumber: '',
        email: '',
    };

    const [showPassword, setShowPassword] = useState(false);
    const [validInput, setValidInput] = useState(validInputDefault);
    const [userData, setUserData] = useState(defaultUserData);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    const [isShowConfirm, setShowConfirm] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        setUserData({
            ...defaultUserData,
            repassword: '',
            userCode: dataModalUserUpdate?.userCode || '',
            phoneNumber: dataModalUserUpdate?.phoneNumber || '',
            email: dataModalUserUpdate?.email || ''
        });
        setIsSaveDisabled(true);
    }, [props.isShow, dataModalUserUpdate]);

    const handleLogout = async () => {
        let data = await logoutUser();

        if (data && data.ok) {
            toast.success('Đã đăng xuất');
            navigate("/login");
        } else {
            toast.error(data?.message || 'Đã đăng xuất');
            navigate("/login");
        }
    };

    const handleOnchangeInput = (value, name) => {
        let _userData = _.cloneDeep(userData);
        _userData[name] = value;
        setUserData(_userData);

        if (!_userData.password && !_userData.email && !_userData.phoneNumber)
            setIsSaveDisabled(true);
        else
            setIsSaveDisabled(false);
    };

    const isEmptyInput = () => {
        setValidInput(validInputDefault);
        let arr = ['email', 'phoneNumber', 'password'];
        let check = true;

        for (let i = 0; i < arr.length; i++) {
            if (!userData[arr[i]]) {
                let _validInput = _.cloneDeep(validInputDefault);
                _validInput[arr[i]] = false;
                setValidInput(_validInput);

                toast.error(`Vui lòng nhập đầy đủ ${arr[i] === 'email' ? 'Email' : arr[i] === 'phoneNumber' ? 'Số điện thoại' : 'Mật khẩu'}`);
                check = false;
                break;
            }
        }
        return check;
    };

    const isValidValue = () => {
        const regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,20}@gmail\.com$/;
        const regexPhone = /^0\d{9}$/;
        const regexPwd = /^[\s\S]{7,16}$/;

        if (regexEmail.test(userData['email']) === false) {
            toast.error('Email không hợp lệ (Phải dùng định dạng @gmail.com)');
            setValidInput({ ...validInputDefault, email: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, email: true });
        }

        if (regexPhone.test(userData['phoneNumber']) === false) {
            toast.error('Số điện thoại không hợp lệ (10 chữ số)');
            setValidInput({ ...validInputDefault, phoneNumber: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, phoneNumber: true });
        }

        if (regexPwd.test(userData['password']) === false) {
            toast.error('Mật khẩu từ 7 - 16 ký tự');
            setValidInput({ ...validInputDefault, password: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, password: true });
        }

        return true;
    };

    const isValidInput = () => {
        return isEmptyInput() && isValidValue();
    };

    const showConfirm = () => {
        if (isValidInput()) {
            setShowConfirm(true);
        }
    };

    const closeConfirm = () => {
        setShowConfirm(false);
    };

    const handleConfirmUser = async () => {
        let response = await updateCurrentUser(userData);
        if (response && response.ok) {
            toast.success('Cập nhật thông tin thành công.');
            closeConfirm();
            props.onClose();
            handleLogout();
        } else {
            toast.error(response?.message || 'Cập nhật thất bại.');
        }
    };

    const handleCloseModalUser = () => {
        props.onClose();
        setUserData(defaultUserData);
        setValidInput(validInputDefault);
    };

    return (
        <>
            <Modal show={props.isShow} className='modal-edit' onHide={handleCloseModalUser} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-pencil-square text-primary"></i>
                        Cập nhật thông tin cá nhân
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="notice-box mb-3">
                        <i className="bi bi-info-circle-fill"></i>
                        <span>Vui lòng cập nhật các thông tin bên dưới và nhập mật khẩu để xác minh.</span>
                    </div>

                    <div className='form-group'>
                        <label>Địa chỉ Email (chỉ hỗ trợ @gmail.com):</label>
                        <input
                            value={userData.email}
                            className={validInput.email ? 'form-control' : 'form-control is-invalid'}
                            type='email'
                            placeholder="Nhập email của bạn..."
                            onChange={(event) => handleOnchangeInput(event.target.value, "email")}
                        />
                        {!validInput.email && <span className='err'>Email phải có đuôi @gmail.com</span>}
                    </div>

                    <div className='form-group'>
                        <label>Số điện thoại:</label>
                        <input
                            value={userData.phoneNumber}
                            className={validInput.phoneNumber ? 'form-control' : 'form-control is-invalid'}
                            type='text'
                            placeholder="Nhập số điện thoại 10 chữ số..."
                            onChange={(event) => handleOnchangeInput(event.target.value, "phoneNumber")}
                        />
                        {!validInput.phoneNumber && <span className='err'>Số điện thoại bắt đầu bằng 0 và gồm 10 chữ số</span>}
                    </div>

                    <hr className="my-3" />

                    <div className='form-group mb-0'>
                        <label>Mật khẩu hiện tại để xác minh:</label>
                        <div className='input-group-pwd'>
                            <input
                                value={userData.password}
                                className={validInput.password ? 'form-control' : 'form-control is-invalid'}
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Nhập mật khẩu để lưu thay đổi..."
                                onChange={(event) => handleOnchangeInput(event.target.value, "password")}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {!validInput.password && <span className='err'>Mật khẩu từ 7 đến 16 ký tự</span>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalUser}>Hủy bỏ</Button>
                    <Button variant="primary" disabled={isSaveDisabled} onClick={showConfirm}>
                        <i className="bi bi-check-circle me-1"></i>
                        Lưu thay đổi
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Confirm Dialog */}
            <Modal show={isShowConfirm} onHide={closeConfirm} className="modal-edit" centered size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="bi bi-exclamation-triangle-fill text-warning"></i>
                        Xác nhận lưu
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-0 text-secondary">
                        Sau khi cập nhật thông tin thành công, hệ thống sẽ tự động đăng xuất để làm mới dữ liệu. Bạn có chắc chắn muốn tiếp tục?
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeConfirm}>Hủy</Button>
                    <Button variant="primary" onClick={handleConfirmUser}>Đồng ý</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalEditUser;